import React, { useState } from 'react';
import { MapPinIcon, TruckIcon, StoreIcon, EditIcon } from 'lucide-react';
import { StoreLocatorModal } from '../modals/StoreLocatorModal';
export function DeliveryInfo() {
  const [storeLocatorOpen, setStoreLocatorOpen] = useState(false);
  return <>
      <div className="rounded-xl border border-gray-200 bg-white shadow-sm p-4 md:p-5" data-id="element-5137" data-mp="16n3l5kudpd8z">
        <h3 className="text-base font-bold text-gray-900 mb-4" data-id="element-5138" data-mp="16pgc2ni46xy6">
          Delivery Information
        </h3>
        {/* Deliver To */}
        <div className="mb-4 p-3 bg-gray-50 rounded-lg" data-id="element-5139" data-mp="1ydrn2z3vmmnp">
          <div className="flex items-start justify-between mb-2" data-id="element-5140" data-mp="1ygcndjoj0ujc">
            <div className="flex items-center gap-2" data-id="element-5141" data-mp="1tm8g0zbcmkhq">
              <MapPinIcon className="w-4 h-4 text-[#1E2B55] flex-shrink-0" data-id="element-5142" data-mp="1pm7rumyg6uxh" />
              <span className="text-sm font-medium text-gray-700" data-id="element-5143" data-mp="1pjv9i8os2ijw">
                Deliver To:
              </span>
            </div>
            <button className="flex items-center gap-1 text-xs font-medium text-[#1E2B55] hover:underline" data-id="element-5144" data-mp="2hcm0o4rlth2a">
              <EditIcon className="w-3 h-3" data-id="element-5145" data-mp="3ges0gesa0t43" />
              Edit
            </button>
          </div>
          <p className="text-xs text-gray-600 ml-6" data-id="element-5146" data-mp="3leee2pc0obdf">
            RFQAB535, B535 Ad Dafnah, 4324, Riyadh, Saudi Arabia
          </p>
        </div>
        {/* Standard Delivery */}
        <div className="p-3 bg-green-50 border border-green-200 rounded-lg mb-3" data-id="element-5147" data-mp="3bo1w94vl6waz">
          <div className="flex items-center gap-2" data-id="element-5148" data-mp="3blyxnwgdbuun">
            <TruckIcon className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-5149" data-mp="2xnr47yijjbo8" />
            <div className="flex-1 min-w-0" data-id="element-5150" data-mp="32o6icsancn79">
              <p className="text-sm font-bold text-gray-900" data-id="element-5151" data-mp="32oycdyolicvf">
                Standard Delivery
              </p>
              <p className="text-xs text-gray-600" data-id="element-5152" data-mp="2nsgz31wuio68">IN 2 - 3 days</p>
            </div>
          </div>
        </div>
        {/* Store Pickup */}
        <div className="p-3 border border-gray-200 rounded-lg" data-id="element-5153" data-mp="lyrj8jnjf66m">
          <div className="flex items-start gap-2 mb-2" data-id="element-5154" data-mp="lx6qmzks9xbe">
            <StoreIcon className="w-4 h-4 text-[#1E2B55] flex-shrink-0 mt-0.5" data-id="element-5155" data-mp="qwt3v90m3dk7" />
            <div className="flex-1 min-w-0" data-id="element-5156" data-mp="ph73jg6v7k17">
              <p className="text-sm font-bold text-gray-900" data-id="element-5157" data-mp="peufclaikdfp">Buy in person?</p>
              <p className="text-xs text-gray-600" data-id="element-5158" data-mp="kg9dyijiznpo">Find nearest store</p>
            </div>
          </div>
          <button onClick={() => setStoreLocatorOpen(true)} className="w-full bg-[#1E2B55] text-white text-sm font-bold py-2 rounded-lg hover:bg-[#162041] transition-colors" data-id="element-5159" data-mp="fj14r7gcuu0k">
            Find Store
          </button>
        </div>
      </div>
      {/* Store Locator Modal */}
      <StoreLocatorModal isOpen={storeLocatorOpen} onClose={() => setStoreLocatorOpen(false)} data-id="element-5160" data-mp="13aexvfmbytml" />
    </>;
}